import { Link } from 'react-router-dom';
import LogisticsPageHero from '../Logistics/LogisticsPageHero';
import { GOOGLE_RATING_VALUE, GOOGLE_REVIEW_COUNT } from '../../seo/companyFacts';

const OUR_REVIEWS_HERO_IMG =
  '/reviews/reviews.webp';

function StarRow() {
  return (
    <div
      className="our-reviews-hero-trust"
      aria-label={`${GOOGLE_RATING_VALUE.toFixed(1)} out of 5 Google rating based on ${GOOGLE_REVIEW_COUNT} reviews`}
    >
      <span className="reviews-trust-excellent">Excellent</span>
      <div className="reviews-trust-stars" aria-hidden>
        {Array.from({ length: 5 }).map((_, i) => (
          <svg key={i} className="star-tp" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
        ))}
      </div>
      <p className="reviews-trust-meta">
        <strong>{GOOGLE_RATING_VALUE.toFixed(1)}</strong> out of 5 · Based on{' '}
        <strong>{GOOGLE_REVIEW_COUNT}</strong> Google reviews
      </p>
    </div>
  );
}

const OurReviewsHero = () => (
  <LogisticsPageHero
    ariaLabel="Pick Pack Pro customer reviews"
    imageSrc={OUR_REVIEWS_HERO_IMG}
    imageAlt="We hear you — Pick Pack Pro UK fulfilment customer reviews and feedback"
    titleLight="Customer Reviews"
    titleAccent="Trusted UK Fulfilment Partner"
    description={
      <>
        <p>
          Read genuine feedback from Amazon, Shopify, TikTok Shop and multi-channel brands that trust Pick Pack Pro for eCommerce fulfilment, Amazon FBA Prep, Seller Fulfilled Prime (SFP), pick and pack services and reliable UK warehouse fulfilment.
        </p>
      </>
    }
    features={[
      'Picking Fee from £0.99',
      'Next Day Shipping from £1.99',
      '99.9% Order Accuracy',
      'Dedicated Account Manager',
      'Price match promise',
    ]}
    ctaSlot={
      <>
        <StarRow />
        <div className="sh-cta-wrapper our-reviews-hero-cta">
          <Link to="/contact-fulfillment-services" className="sh-cta-btn">
            Become a client
          </Link>
        </div>
      </>
    }
  />
);

export default OurReviewsHero;
